import { useLang } from "@/i18n";
import { PageHero } from "@/components/PageHero";

export default function Legal() {
  const { t, pageKey } = useLang();
  const isPrivacy = pageKey === "privacy";
  const title = isPrivacy ? t.legal.privacyTitle : t.legal.cookiesTitle;
  const blocks = isPrivacy ? t.legal.privacy : t.legal.cookies;
  return (
    <>
      <PageHero eyebrow="MADE ONLUS" lines={[title]} />
      <section className="pb-24" data-testid={`legal-${pageKey}`}>
        <div className="wrap"><div className="max-w-3xl">
          {blocks.map(([h, p]) => (
            <div key={h} className="py-7 border-t border-[var(--line)]">
              <h2 className="text-2xl sm:text-3xl">{h}</h2>
              <p className="mt-3 text-[var(--ink-soft)] leading-relaxed">{p}</p>
            </div>
          ))}
        </div></div>
      </section>
    </>
  );
}
